import { Box, Tooltip as MuiTooltip, Typography } from '@mui/material';

const tooltipSx = {
	backgroundColor: 'transparent',
	borderRadius: 1,
	p: 0,
	ml: 0,
	mr: 0,
	whiteSpace: 'normal'
};

function LargeTooltip({ placement = 'top', title, content, ...props }) {
	return (
		<MuiTooltip
			placement={placement}
			enterTouchDelay={100}
			arrow={false}
			slotProps={{
				tooltip: {
					sx: tooltipSx
				}
			}}
			title={
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-start',
						backgroundColor: '#ffffff',
						boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.20)',
						p: '8px',
						gap: '4px',
						borderRadius: 2,
						maxWidth: 281
					}}
				>
					<Typography
						variant="body1"
						sx={{
							color: 'text.primary',
							fontWeight: 700
						}}
					>
						{title}
					</Typography>

					<Typography
						variant="body0"
						sx={{
							color: 'neutral.600',
							fontWeight: 400
						}}
					>
						{content}
					</Typography>
				</Box>
			}
			{...props}
		/>
	);
}

export default LargeTooltip;
